module.exports = __webpack_public_path__ + "static/media/partners-hero-d.ba42c308.webp";